interface MDVIPLogoProps {
  className?: string;
}

/**
 * MDVIP Logo component
 * Reusable SVG logo that can be styled via className
 */
export function MDVIPLogo({ className = 'h-7 w-auto' }: MDVIPLogoProps) {
  return (
    <svg
      width="114"
      height="26"
      viewBox="0 0 114 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="MDVIP Logo"
    >
      <path
        d="M32.9292 0.746262V23.5529H29.5931V0.746262H22.8172L15.4029 17.358L7.1776 0.746262H0.00488281V25.336H3.41581V6.29117L12.8893 25.3302H15.6445L24.1459 6.30267V19.8371C24.1459 24.1913 26.6193 25.3302 29.6391 25.3302H43.2137C50.5878 25.3302 56.7194 21.3211 56.7194 12.9635C56.7194 4.60584 50.9271 0.746262 42.5177 0.746262H32.9292ZM42.4717 22.6613H38.5144V3.42093H42.0288C47.4184 3.42093 50.6395 6.73407 50.6395 12.9174C50.6395 19.1008 47.4242 22.6613 42.4257 22.6613H42.4775H42.4717ZM91.8122 0.746262V25.336H97.4549V17.0244H103.391C109.131 17.0244 113.238 14.0563 113.238 8.90832C113.238 3.7603 109.126 0.746262 103.385 0.746262H91.8064H91.8122ZM97.4491 14.3037V3.46695H101.458C105.663 3.46695 107.987 5.29608 107.987 8.81053C107.987 12.325 105.663 14.3037 101.458 14.3037H97.4491ZM88.4703 0.746262V25.3302H82.8334V3.00104H81.0042L70.9153 25.3302H67.1535L54.9938 0.746262H61.0276L69.4888 17.6628L70.0812 18.8477L76.673 4.13418C78.0592 0.976341 80.1127 0.746262 82.7816 0.746262H88.4703Z"
        fill="currentColor"
      />
    </svg>
  );
}
